export const buildStashesSearchParamsForInput = (currentParams: URLSearchParams, value: string) => {
  const next = new URLSearchParams(currentParams);
  const trimmed = value.trim();

  if (trimmed) {
    next.set("q", trimmed);
  } else {
    next.delete("q");
  }

  next.delete("offset");
  return next;
};

export const shouldShowStashesSearchClear = (value: string) => value.trim().length > 0;
